module.exports = __webpack_public_path__ + "img/arrow-down.279d2aa6.svg";